import React from "react";
import { PAGE_SIZES } from "./memberColumns";

const MemberFootBar = ({
    pageSize,
    totalRecords,
    currentPage,
    totalPages,
    pageNumbers,
    onPageSizeChange,
    onPageChange,
}) => (
    <div className="vp-mfoot-bar">
        <div className="vp-mpage-size">
            <select
                value={pageSize}
                onChange={(e) => onPageSizeChange(Number(e.target.value))}
            >
                {PAGE_SIZES.map((size) => (
                    <option value={size} key={size}>
                        {size}
                    </option>
                ))}
            </select>
            <span>{totalRecords} Records</span>
        </div>
        <div className="vp-mpager">
            <button
                type="button"
                disabled={currentPage === 1}
                onClick={() => onPageChange(1)}
            >
                «
            </button>
            <button
                type="button"
                disabled={currentPage === 1}
                onClick={() => onPageChange(currentPage - 1)}
            >
                ‹
            </button>
            {pageNumbers.map((pageNumber) => (
                <button
                    type="button"
                    key={pageNumber}
                    className={pageNumber === currentPage ? "active" : ""}
                    onClick={() => onPageChange(pageNumber)}
                >
                    {pageNumber}
                </button>
            ))}
            <button
                type="button"
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(currentPage + 1)}
            >
                ›
            </button>
            <button
                type="button"
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(totalPages)}
            >
                »
            </button>
        </div>
    </div>
);

export default MemberFootBar;
